import {AfterViewInit, Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {NgbModal, NgbModalConfig} from "@ng-bootstrap/ng-bootstrap";
import {CookieService} from "./shared/services/cookie.service";
import {GoogleTagManagerService} from "./shared/services/google-tag-manager.service ";

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	providers: [NgbModalConfig, NgbModal]
})
export class AppComponent implements OnInit, AfterViewInit {
	lang = new Subject<string>();
	lang$: Observable<string>;
	title = 'dashboard-app';

	private gtmLoaded = false;

	constructor(private translate: TranslateService,
				private cookies: CookieService,
				private gtm: GoogleTagManagerService,
				private ngbModalConfig: NgbModalConfig) {

		// this language will be used as a fallback when a translation isn't found in the current language
		// translate.setDefaultLang('de');

		// the lang to use, if the lang isn't available, it will use the current loader to get them
		// translate.use('de');

		this.setUpNGBConfigs()
	}


	ngOnInit(): void {

		console.log("analytics activated ? ",this.cookies.isAllowed("analytics"));

		this.cookies.changes.subscribe(allowed => {
			console.log("cookies changed",allowed);

			if (this.cookies.isAllowed("analytics")) {
				this.gtm.enableTracking();
				//this.loadGoogleTagManager(false);
			}else{

				this.gtm.disableTracking()
			}

		});

		if (this.cookies.isAllowed("analytics")) {
			//this.loadGoogleTagManager(true);
			this.gtm.enableTracking();
		}
	}

	ngAfterViewInit(): void {
	}

	private setUpNGBConfigs() {
		this.ngbModalConfig.scrollable = true;
	}



	//alternative version, already replaced by gtm-service:
	loadGoogleTagManager(onInit = true): void {
		// avoid multiple loading
		if (this.gtmLoaded) {
			return;
		}

		console.log("init GTM");


		this.gtmLoaded = true;

		const gtmId = 'GTM-P3GBK2WB';

		const w = window as typeof window & {
			dataLayer?: Record<string, unknown>[];
		};

		w.dataLayer = w.dataLayer || [];
		w.dataLayer.push({
			'gtm.start': new Date().getTime(),
			event: 'gtm.js'
		});

		// Script erstellen
		const script = document.createElement('script');
		script.async = true;
		script.src =
			`https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

		// after body tag
		document.body.insertBefore(script, document.body.firstChild);
	}

/*
	configureGoogleAnalytics(onInit = true): void {
		if (this.cookies.isAllowed("analytics")) {

		  GoogleAnalyticsInitializer();

		  //if not already existing, add tag:
		  if (!this.currentAnalyticsStatus) {

		    console.log("add script tag!");
		    const trackingID = 'G-D3YYK50Z3K';

		    // Dynamically load the gtag.js script if consent is given
		    const gaScript = document.createElement('script');
		    gaScript.setAttribute('async', 'true');
		    gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${trackingID}`);

		    const gaScript2 = document.createElement('script');
		    gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${trackingID}\');`;

		    document.documentElement.firstChild.appendChild(gaScript);
		    document.documentElement.firstChild.appendChild(gaScript2);

		    this.currentAnalyticsStatus = true;
		  } else {
		    console.log("ignore script tag!");
		  }
		} else {
		  if (!onInit) {
		    window.location.reload();
		  }
		}

	}

 */

}
